import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import addDays from "@insite/client-framework/Common/Utilities/addDays";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import clearForm from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/ClearForm";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";

import translate from "@insite/client-framework/Translate";
import { CountryModel, StateModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";

import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@insite/mobius/DatePicker";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Link from "@insite/mobius/Link";
import Radio, { RadioComponentProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupComponentProps } from "@insite/mobius/RadioGroup";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import FieldSetPresentationProps, { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CreditApplicationFormModel } from "@tCooneyBrothers/ApiModels";
import { formatPhoneNumber } from "@tCooneyBrothers/Common/Utilities/formatPhoneNumber";
import { CallbackType, ErrorObjectType, InputObjectType, validate } from "@tCooneyBrothers/Common/Utilities/validate";
import { CreateAccountExistingFormStyles } from "@tCooneyBrothers/Components/CreateAccountExistingForm";
import { CreateAccountNewFormStyles } from "@tCooneyBrothers/Components/CreateAccountNewForm";
import {
    FormErrorsStateType,
    intialErrorFormStateForCreditApp,
    newCustomerCreditValidatorConfig,
    ValidatorConfigType,
} from "@tCooneyBrothers/Components/CreditApplicationFormValidatorConfig";
import addCreditApplicationFormFields from "@tCooneyBrothers/Handlers/CreditApplicationFormHandler";
import loadUserDetails from "@tCooneyBrothers/Handlers/LoadUserDetails";
import CustomApplicationState from "@tCooneyBrothers/Store/CustomApplicationState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import ReCaptcha from "@tCooneyBrothers/Components/ReCaptcha";
import { FC, RefObject } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
}

interface MessageFilterStyles {
    radioGroup?: FieldSetGroupPresentationProps<RadioGroupComponentProps>;
    radioButton?: FieldSetPresentationProps<RadioComponentProps>;
}

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomApplicationState) => ({
    countries: getCurrentCountries(state),
    shouldLoadCountries: !getCurrentCountries(state),
    sessionData: state.context?.session,
    userDatails: state.cbData.userDetails.value,
    // companyName: state.components.contactUsForm.fieldValues["companyName"],
});

const mapDispatchToProps = {
    setFieldValue,
    loadCurrentCountries,
    addCreditApplicationFormFields,
    loadUserDetails,
    validateReCaptcha: makeHandlerChainAwaitable<{ location: string; recaptchaRef: RefObject<ReCAPTCHA | null> }, boolean>(
        validateReCaptcha,
    ),
};


type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CreditApplicationFormStyles {
    wrapper?: InjectableCss;
    addressText?: TypographyProps;
    cityStatePostalCodeText?: TypographyProps;
    countryText?: TypographyProps;
    mainGridContainer?: GridContainerProps;
    userGridItem?: GridItemProps;
    userGridContainer?: GridContainerProps;
    emailGridItem?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    userNameGridItem?: GridItemProps;
    userNameTextField?: TextFieldPresentationProps;
    // fullWidthForMobileDevices?: InjectableCss;
    passwordGridItem?: GridItemProps;
    passwordTextField?: TextFieldPresentationProps;
    confirmPasswordTextField?: TextFieldPresentationProps;
    confirmPasswordGridItem?: GridItemProps;
    confirmPasswordIcon?: IconPresentationProps;
    subscriptionGridItem?: GridItemProps;
    submitErrorGridItem?: GridItemProps;
    submitErrorTitle?: TypographyProps;
    submitGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    centeringWrapper?: InjectableCss;
    requirementsGridItem?: GridItemProps;
    passwordRequirementsGridContainer?: GridContainerProps;
    passwordRequirementsGridItem?: GridItemProps;
    requirementsTitle?: TypographyProps;
    formsTopNav?: InjectableCss;
    passwordIcon?: IconPresentationProps;
    messageFilterGridItem?: GridItemProps;
    messageFilter?: MessageFilterStyles;
    fromDate?: DatePickerPresentationProps;
    attributeTypeText?: TypographyPresentationProps;
    select?: SelectPresentationProps;
    CreateAccountExistingFormStyles?: CreateAccountExistingFormStyles;
    createAccountNewFormStyles?: CreateAccountNewFormStyles;
    subHeading?: InjectableCss;
    refCustomInputCss?: InjectableCss;
    sectionLabel?: InjectableCss;
    sectionDivider?: InjectableCss;
    halfWidthCustomInputCss?: InjectableCss;
    halfWidthCustomInputCss1?: InjectableCss;
    columnLayout?: InjectableCss;
    borderTop?: InjectableCss;
    borderBottom?: InjectableCss;
    radioWithFlex?: InjectableCss;
    departmentSelect: SelectPresentationProps;
    formStepsNumber?: InjectableCss;
    formStepsHeading?: InjectableCss;
    centerAlignFlexbox?: InjectableCss;
    underline?: InjectableCss;
    errorMessageStyle?: InjectableCss;
    startDateGridItem?: GridItemProps;
    startDatePicker?: DatePickerPresentationProps;
    halfWidthDatePickerCss?: InjectableCss;
    shipToBillToCheck?: InjectableCss;
    creditApplicationLastDiv?: InjectableCss;
    marginBottom?: InjectableCss;
    oneFourthGridItem?: GridItemProps;
    thirdFourthGridItem?: GridItemProps;
    inputWithLenthyLabelCss?: InjectableCss;
    fullWidthInput?: InjectableCss;
    captchaWrapper?: InjectableCss;
}

export const creditApplicationFormStyles: CreditApplicationFormStyles = {
    wrapper: {
        css: css`
            font-style: normal;
            [class^="CheckboxGroupStyle"] {
                margin-top: 0 !important;
            }
            [class^="RadioGroupStyle"] {
                legend {
                    margin: 0;
                }
            }
            .fullWidthForMobileDevices {
                > div {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                css`
                                    width: 100% !important;
                                `,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
    addressText: { as: "p" },
    cityStatePostalCodeText: { as: "p" },
    countryText: { as: "p" },
    centeringWrapper: {
        css: css`
            display: flex;
            height: 300px;
            justify-content: center;
            align-items: center;
        `,
    },
    userGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
        padding - left: 100 px;
        `,
                    ],
                    "min",
                )}
        `,
    },
    userGridContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
        max - width: 300 px;
        `,
                    ],
                    "min",
                )}
        `,
    },
    emailGridItem: {
        width: 12,
    },
    userNameGridItem: {
        width: 12,
    },
    passwordGridItem: {
        width: 12,
    },
    confirmPasswordGridItem: {
        width: 12,
    },
    subscriptionGridItem: {
        width: 12,
    },
    submitErrorGridItem: {
        width: 12,
    },
    submitErrorTitle: {
        color: "danger",
    },
    submitGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    requirementsGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
        padding - left: 50 px;
        `,
                    ],
                    "min",
                )}/* stylelint-disable-line declaration-block-single-line-max-declarations */
        `,
    },
    passwordRequirementsGridContainer: {
        gap: 5,
    },
    passwordRequirementsGridItem: {
        width: 12,
    },
    requirementsTitle: {
        variant: "h4",
        as: "h2",
    },
    formsTopNav: {
        css: css`
            display: flex;
        `,
    },
    messageFilterGridItem: { width: 12 },
    messageFilter: {
        radioGroup: {
            css: css`
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                justify-content: flex-start;
                            `,
                        ],
                        "max",
                    )}
            `,
        },
        radioButton: {
            css: css`
                margin-top: 0 !important;
                margin-right: 20px;
                label {
                    font-size: 13px;
                }
            `,
        },
    },
    fromDate: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
            formField: css`
                padding-right: 10px;
            `,
        },
    },
    subHeading: {
        css: css`
            background-color: #ef3742;
            color: #fff;
            text-transform: uppercase;
            width: 100%;
            padding: 8px 15px;
            /* margin-bottom: 30px; */
            font-weight: bold;
        `,
    },
    refCustomInputCss: {
        css: css`
            max-width: 100%;
            width: 100%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            margin-top: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: 100%;
                        `,
                    ],
                    "max",
                )}
            > div[class^="FormFieldStyle"] {
                position: relative;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    left: 14px;
                                    padding-left: 3px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
    sectionLabel: {
        css: css`
            color: #0f0f0f;
            font-weight: 600;
        `,
    },
    sectionDivider: {
        css: css`
            border-bottom: 1px solid #efefef;
            margin-top: 10px;
            padding-bottom: 20px;
            margin-bottom: 20px;
            padding-left: 0;
            padding-right: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-direction: column;
                            display: block;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    departmentSelect: {
        labelProps: {
            css: css`
                width: 100%;
            `,
        },
        cssOverrides: {
            formField: css`
                width: 100%;
            `,
        },
    },
    halfWidthCustomInputCss: {
        css: css`
            width: 50%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            margin-top: 10px;
            padding-right: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            padding-right: 0px;
                        `,
                    ],
                    "max",
                )}
            > div[class^="FormFieldStyle"] {
                position: relative;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    left: 14px;
                                    padding-left: 3px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
    halfWidthCustomInputCss1: {
        css: css`
            width: 50%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            margin-top: 10px;
            padding-right: 30px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            padding-right: 0px;
                        `,
                    ],
                    "max",
                )}
            > div[class^="FormFieldStyle"] {
                position: relative;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    left: 14px;
                                    padding-left: 3px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
    inputWithLenthyLabelCss: {
        css: css`
            width: 100%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            margin-top: 10px;
            padding-right: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            padding-right: 0px;
                        `,
                    ],
                    "max",
                )}
            > div[class^="FormFieldStyle"] {
                position: relative;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    left: 14px;
                                    padding-left: 3px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
    borderTop: {
        css: css`
            border-top: 1px solid #efefef;
        `,
    },
    borderBottom: {
        css: css`
            border-bottom: 1px solid #efefef;
        `,
    },
    radioWithFlex: {
        css: css`
            display: flex;
            justify-content: flex-start;
            flex-direction: row;
            > div[class^="RadioStyle"] {
                margin-right: 10px;
                margin-top: 0;
            }
        `,
    },
    formStepsNumber: {
        css: css`
            font-size: 100px;
            font-weight: bold;
            padding-right: 5px;
            color: #e9e9e9;
        `,
    },
    formStepsHeading: {
        css: css`
            text-transform: capitalize;
            font-weight: bold;
        `,
    },
    centerAlignFlexbox: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            margin-bottom: 10px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    underline: {
        css: css`
            text-decoration: underline;
            // text-transform: uppercase;
            color: ${getColor("primary")};
            span {
                color: ${getColor("primary")} !important;
                font-size: 14px;
                font-weight: 600;
            }
        `,
    },
    errorMessageStyle: {
        css: css`
            //color: ${getColor("danger")};
            color: #1a3065;
            font-weight: 600;
            padding: 10px;
            width: 100%;
            background-color: #ff9832;
        `,
    },
    startDateGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
            align-items: initial;
        `,
    },
    halfWidthDatePickerCss: {
        css: css`
            width: 50%;
            display: inline-block;
            vertical-align: top;
            margin-bottom: 10px;
            margin-top: 10px;
            padding-right: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            padding-right: 0px;
                        `,
                    ],
                    "max",
                )}
            > div[class^="FormFieldStyle"] {
                position: relative;
                width: 100%;
                > label {
                    font-size: 13px;
                    position: absolute;
                    z-index: 1;
                    padding-left: 5px;
                    background-color: #fff;
                    display: inline-block;
                    width: auto;
                    left: 20px;
                    min-height: 19px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                css`
                                    font-size: 12px;
                                    left: 14px;
                                    padding-left: 3px;
                                `,
                                null,
                                null,
                            ],
                            "max",
                        )}
                }
            }
        `,
    },
    shipToBillToCheck: {
        css: css`
            margin-top: 15px;
            width: 100%;
        `,
    },
    marginBottom: {
        css: css`
            margin-bottom: 30px;
        `,
    },
    creditApplicationLastDiv: {
        css: css`
            padding: 15px 0 !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-direction: column;
                            display: block;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    oneFourthGridItem: {
        width: [12, 12, 12, 4, 4],
        css: css`
            padding: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: block;
                            padding: 0 0 15px;
                        `,
                    ],
                    "max",
                )}
        `,
    },

    thirdFourthGridItem: {
        width: [12, 12, 12, 5, 5],
        css: css`
            flex-direction: column;
            padding: 0 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: block;
                            padding: 0;
                        `,
                    ],
                    "max",
                )}
            > div[class^="sc-"] {
                > div[class^="RadioGroupStyle"] {
                    > span[class^="TypographyStyle"] {
                        display: block;
                        font-size: 13px;
                    }
                }
            }
        `,
    },

    columnLayout: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    fullWidthInput: {
        css: css`
            width: 100%;
            margin-top: 15px;
        `,
    },
    captchaWrapper: {
        css: css`
            margin-bottom: 15px;
        `
    }
};

const styles = creditApplicationFormStyles;

const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

const CreditApplicationForm: React.FC<Props> = ({
    countries,
    shouldLoadCountries,
    sessionData,
    userDatails,
    loadCurrentCountries,
    addCreditApplicationFormFields,
    loadUserDetails,
    validateReCaptcha
}) => {
    if (shouldLoadCountries) {
        loadCurrentCountries();
    }

    if (!countries) {
        return null;
    }

    const selCountry = countries?.find(option => option.name === "United States");

    const emailRequiredFieldMessage = siteMessage("Please enter email address");
    const billingEmailValidateFieldMessage = siteMessage("creditApplicationForm_billingEmail_Validate");
    const shippingEmailRequiredFieldMessage = siteMessage("creditApplicationForm_shippingEmail_Required");
    const shippingEmailValidateFieldMessage = siteMessage("creditApplicationForm_shippingEmail_Validate");
    const emailFieldMessage = siteMessage("creditApplicationForm_EmailAddress_ValidEmail");
    const billingAddressErrorMsg = siteMessage("creditApplicationForm_bllingAddress_Required");
    const billingAddresslengthErrorMsg = siteMessage("creditApplicationForm_bllingAddress-length_Required");
    const billTocityErrorMsg = siteMessage("creditApplicationForm_bllingAddress_billToCityRequired");
    const billToCityValidateErrorMsg = siteMessage("creditApplicationForm_bllingAddress_billToCity_validate");
    const shippingAddressErrorMsg = siteMessage("creditApplicationForm_shippingAddress_Required");
    const shippingAddressValidErrorMsg = siteMessage("creditApplicationForm_shippingAddress-valid");
    const shipToCityErrorMsg = siteMessage("Please Enter Shipping City.");
    const shipToCityValidateErrorMsg = siteMessage("creditApplicationForm_shippingAddress_ShipToCity_validate");
    const billingPostalCodeErrorMsg = siteMessage("creditApplicationForm_bllingPostalcodeRequired");
    const billingPostalCodeValidateErrorMsg = siteMessage("creditApplicationForm_bllingPostalcodeValidate");
    const shippingPostalCodeValidateErrorMsg = siteMessage("creditApplicationForm_shippingPostalcodeValidate");
    const shippingPostalCodeErrorMsg = siteMessage("creditApplicationForm_ShippingPostalcodeRequired");
    const phoneErrorMsg = siteMessage("creditApplicationForm_PhoneNoRequired");
    const validPhoneMsg = siteMessage("creditApplicationForm_PhoneNoValidation");
    const companyOperationalTimeErrorMsg = siteMessage("creditApplicationForm_companyOperationalTime_Required");
    const principalActivityErrorMsg = siteMessage("creditApplicationForm_principalActivity_Required");
    const pastBuyerNameErrorMsg = siteMessage("creditApplicationForm_pastBuyerName_Required");
    const isCompanyNameChangedErrorMsg = siteMessage("creditApplicationForm_isCompanyNameChanged_Required");
    const apContactErrorMsg = siteMessage("creditApplicationForm_apContact_Required");
    const apContactEmailRequiredFieldMessage = siteMessage("creditApplicationForm_apContactEmai_Required");
    const apContactEmailValidateFieldMessage = siteMessage("creditApplicationForm_apContactEmail_Validate");
    const bankNameErrorMsg = siteMessage("creditApplicationForm_bankName_Required");
    const bankNameValidateErrorMsg = siteMessage("creditApplicationForm_bankNamelength_Required");
    const accountErrorMsg = siteMessage("creditApplicationForm_account_Required");
    const accountValidateErrorMsg = siteMessage("creditApplicationForm_accountlength_Required");
    const bankAddressErrorMsg = siteMessage("creditApplicationForm_bankAddress_Required");
    const bankAddressValidateErrorMsg = siteMessage("creditApplicationForm_bankAddress_validation");
    const brcPhoneErrorMsg = siteMessage("creditApplicationForm_BankPhoneNo_Required");
    const ref1CompanyNameErrorMsg = siteMessage("creditApplicationForm_ref1CompanyName_Required");
    const ref1CompanyNameValidateErrorMsg = siteMessage("creditApplicationForm_ref1CompanyName_validation");
    const ref2CompanyNameErrorMsg = siteMessage("creditApplicationForm_ref2CompanyName_Required");
    const ref2CompanyNameValidateErrorMsg = siteMessage("creditApplicationForm_ref2CompanyName_validation");
    const businessRefName1ErrorMsg = siteMessage("creditApplicationForm_businessRefName1_Required");
    const businessRefName1ValidateErrorMsg = siteMessage("creditApplicationForm_businessRefName1_validation");
    const businessRefName2ErrorMsg = siteMessage("creditApplicationForm_businessRefName2_Required");
    const businessRefName2ValidateErrorMsg = siteMessage("creditApplicationForm_businessRefName2_validation");
    const businessRefAddress1ErrorMsg = siteMessage("creditApplicationForm_businessRefAddress1_Required");
    const businessRefAddress1ValidateErrorMsg = siteMessage("creditApplicationForm_businessRefAddress1_validation");
    const businessRefAddress2ErrorMsg = siteMessage("creditApplicationForm_businessRefAddress2_Required");
    const businessRefAddress2ValidateErrorMsg = siteMessage(
        "Second Businesss Reference Address should contain at least 2 characters.",
    );
    const businessRefPhone1ErrorMsg = siteMessage("creditApplicationForm_BankPhoneNo_Required");
    const businessRefPhone2ErrorMsg = siteMessage("creditApplicationForm_BankPhoneNo_Required");
    const upsAccountErrorMsg = siteMessage("creditApplicationForm_upsAccount_Required");
    const receivingHoursErrorMsg = siteMessage("creditApplicationForm_receivingHours_Required");
    const IsSuitFiledErrorMsg = siteMessage("creditApplicationForm_IsSuitFiledError_Required");
    const invEmailRequiredFieldMessage = siteMessage("creditApplicationForm_invEmail_Required");
    const invEmailValidateFieldMessage = siteMessage("creditApplicationForm_invEmail_Validate");
    const invFaxNumberTextErrorMsg = siteMessage("creditApplicationForm_invFaxNumber_Required");
    const invFaxNumberTextValidErrorMsg = siteMessage("creditApplicationForm_invFaxNumber_Valid");
    const isTermsErrorMsg = siteMessage("creditApplicationForm_isTerms_Required");
    const businessRefEmailValidateFieldMessage = siteMessage("creditApplicationForm_businessRefEmail_Validate");

    const [country, setCountry] = React.useState<CountryModel | undefined>(selCountry);
    const defaultCountry = country || selCountry;
    const [billToState, setbillToState] = React.useState<StateModel | undefined>(
        selCountry && selCountry.states ? selCountry.states[0] : undefined,
    );
    const [shipToCountry, setShipToCountry] = React.useState<CountryModel | undefined>(selCountry);
    const defaultShipToCountry = shipToCountry || selCountry;
    const [shipToState, setShipToState] = React.useState<StateModel | undefined>(
        selCountry && selCountry.states ? selCountry.states[0] : undefined,
    );
    const [errorMessage, setErrorMessage] = React.useState("");
    const [IsCreditAccount, setIsCreditAccount] = React.useState(false);
    const [organizationStructure, setOrganizationStructure] = React.useState("");
    const [stateDateIncorporated, setStateDateIncorporated] = React.useState("");
    const [companyOperationalTime, setCompanyOperationalTime] = React.useState("");
    const [companyOperationalTimeError, setcompanyOperationalTimeError] =
        React.useState(companyOperationalTimeErrorMsg);

    const [principalActivity, setPrincipalActivity] = React.useState("");
    const [principalActivityError, setprincipalActivityError] = React.useState(principalActivityErrorMsg);

    const [IsCompanyNameChanged, setIsCompanyNameChanged] = React.useState("No");
    const [formerName, setFormerName] = React.useState("");
    const [formerNameError, setFormerNamerror] = React.useState(isCompanyNameChangedErrorMsg);
    const [IsPastBought, setIsPastBought] = React.useState("No");

    const [pastBuyerName, setPastBuyerName] = React.useState("");
    const [pastBuyerNameError, setPastBuyerNameError] = React.useState(pastBuyerNameErrorMsg);

    const [creditLimit, setCreditLimit] = React.useState("");
    const [IsSalesTaxExempt, setIsSalesTaxExempt] = React.useState("No");

    const [apContact, setApContact] = React.useState("");
    const [apContactError, setApContactError] = React.useState(apContactErrorMsg);
    const [apContactEmail, setApContactEmail] = React.useState("");
    const [apContactEmailError, setApContactEmailError] = React.useState(apContactEmailRequiredFieldMessage);

    const [shippingInfoCompanyName, setShippingInfoCompanyName] = React.useState("");
    const [shippingDate, setShippingDate] = React.useState<Date>(new Date());

    const [shippingAdress, setShippingAdress] = React.useState("");
    const [shippingAddressError, setShippingAddressError] = React.useState(shippingAddressErrorMsg);
    const [shippingCity, setShippingCity] = React.useState("");
    const [shippingCityError, setshippingCityError] = React.useState(shipToCityErrorMsg);
    const [shippingPostalCode, setShippingPostalCode] = React.useState("");
    const [shippingPostalCodeError, setshippingPostalCodeError] = React.useState(shippingPostalCodeErrorMsg);

    const [shippingPhone, setShippingPhone] = React.useState("");
    const [shippingPhoneError, setShippingPhoneError] = React.useState(phoneErrorMsg);

    const [shippingFax, setShippingFax] = React.useState("");
    const [shippingEmail, setshippingEmail] = React.useState("");
    const [shippingEmailError, setShippingEmailError] = React.useState(shippingEmailRequiredFieldMessage);

    const [CompanyName, setCompanyName] = React.useState("");
    const [UserName, setUserName] = React.useState("");
    const [userEmail, setUserEmail] = React.useState("");
    const [emailError, setEmailError] = React.useState(emailRequiredFieldMessage);
    const [billingDate, setDate] = React.useState<Date>(new Date());

    const [billingAdress, setBillingAdress] = React.useState("");
    const [billingAddressError, setBillingAddressError] = React.useState(billingAddressErrorMsg);
    const [billingCity, setBillingCity] = React.useState("");
    const [billingCityError, setBillingCityError] = React.useState(billTocityErrorMsg);
    const [billingPostalCode, setBillingPostalCode] = React.useState("");
    const [billingPostalCodeError, setBillingPostalCodeError] = React.useState(billingPostalCodeErrorMsg);

    const [billingPhone, setBillingPhone] = React.useState("");
    const [billingPhoneError, setBillingPhoneError] = React.useState(phoneErrorMsg);

    const [billingFax, setBillingFax] = React.useState("");
    const [billingEmail, setBillingEmail] = React.useState("");
    const [billingEmailError, setBillingEmailError] = React.useState(emailRequiredFieldMessage);

    const [bankName, setBrcFirstname] = React.useState("");
    const [bankNameError, setBankNameError] = React.useState(bankNameErrorMsg);
    const [bankAccount, setBrcAccount] = React.useState("");
    const [bankAccountError, setAcountError] = React.useState(accountErrorMsg);
    const [bankAddress, setBrcAddress] = React.useState("");
    const [bankAddressError, setbankAddressError] = React.useState(bankAddressErrorMsg);

    const [bankPhone, setBrcPhoneNumber] = React.useState("");
    const [brcPhoneError, setBrcPhoneError] = React.useState(brcPhoneErrorMsg);

    const [bankFax, setBrcFax] = React.useState("");
    const [businessRefCompName1, setBusinessRefCompName1] = React.useState("");
    const [Ref1companyError, setRef1CompanyError] = React.useState(ref1CompanyNameErrorMsg);

    const [businessRefName1, setBusinessRefName1] = React.useState("");
    const [businessRefName1Error, setBusinessRefName1Error] = React.useState(businessRefName1ErrorMsg);

    const [businessRefTitle1, setBusinessRefTitle1] = React.useState("");
    const [businessRefAddress1, setBusinessRefAddress1] = React.useState("");
    const [businessRefAddress1Error, setBusinessRefAddress1Error] = React.useState(businessRefAddress1ErrorMsg);

    const [businessRefPhone1, setBusinessRefPhone1] = React.useState("");
    const [businessRefPhone1Error, setBusinessRefPhone1Error] = React.useState(businessRefPhone1ErrorMsg);

    const [businessRefFax1, setBusinessRefFax1] = React.useState("");
    const [businessRefEmail1, setBusinessRefEmail1] = React.useState("");
    const [businessRefCompName2, setBusinessRefCompName2] = React.useState("");
    const [Ref2companyError, setRef2CompanyError] = React.useState(ref2CompanyNameErrorMsg);

    const [businessRefName2, setBusinessRefName2] = React.useState("");
    const [businessRefName2Error, setBusinessRefName2Error] = React.useState(businessRefName2ErrorMsg);

    const [businessRefTitle2, setBusinessRefTitle2] = React.useState("");
    const [businessRefAddress2, setBusinessRefAddress2] = React.useState("");
    const [businessRefAddress2Error, setBusinessRefAddress2Error] = React.useState(businessRefAddress2ErrorMsg);

    const [businessRefPhone2, setBusinessRefPhone2] = React.useState("");
    const [businessRefPhone2Error, setBusinessRefPhone2Error] = React.useState(businessRefPhone2ErrorMsg);

    const [businessRefFax2, setBusinessRefFax2] = React.useState("");
    const [businessRefEmail2, setBusinessRefEmail2] = React.useState("");
    const [IsBankrupt, setIsBankrupt] = React.useState("No");
    const [IsSuitFiled, setIsSuitFiled] = React.useState("No");
    const [IsUpsAccount, setIsUpsAccount] = React.useState("");
    const [upsAccount, setUpsAccount] = React.useState("");
    const [upsAccountError, setUpsAccountError] = React.useState(upsAccountErrorMsg);

    const [receivingHours, setReceivingHours] = React.useState("");
    const [receivingHoursError, setReceivingHoursError] = React.useState(receivingHoursErrorMsg);

    const [IsTerms, setIsTerms] = React.useState("");
    const [isTermsError, setIsTermsError] = React.useState(isTermsErrorMsg);

    const [InvoicesBeSent, setInvoicesBeSent] = React.useState("e-mail");
    const [invEmailText, setInvEmail] = React.useState("");
    const [invEmailError, setInvEmailEmailError] = React.useState(invEmailRequiredFieldMessage);
    const [businessRef1EmailError, setBusinessRef1EmailEmailError] = React.useState<any>("");
    const [businessRef2EmailError, setBusinessRef2EmailEmailError] = React.useState<any>("");

    const [invFaxNumberText, setInvFaxNumber] = React.useState("");
    const [invFaxNumberTextError, setInvFaxNumberTextError] = React.useState(invFaxNumberTextErrorMsg);

    const [invUSPostalMail, setUSPostalMail] = React.useState("");
    const [invFlag, setInvFlag] = React.useState("");
    const [suitFiledText, setSuitFiledText] = React.useState("");
    const [IsBankruptText, setIsBankruptText] = React.useState("");
    const [formErrorsForCredit, setFormErrorsForCredit] = React.useState<FormErrorsStateType>(
        intialErrorFormStateForCreditApp,
    );
    const [IsShipToSameAsBilling, setIsShipToSameAsBillTo] = React.useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [isCreditFormButtonDisabled, setIsCreditFormButtonDisabled] = React.useState(true);
    const [businessStartDate, setBusinessStartDate] = React.useState("");
    const StyledSpan = getStyledWrapper("span");
    const [isSubmitted, setIsSubmitted] = React.useState(false);

    const recaptchaRef: RefObject<ReCAPTCHA | null> = React.createRef();

    const validateEmail = (input: HTMLInputElement) => {
        const errorMessage = !input.value
            ? emailRequiredFieldMessage
            : emailRegexp.test(input.value)
            ? ""
            : emailFieldMessage;
        setEmailError(errorMessage);
        return !errorMessage;
    };

    React.useEffect(() => {
        if (sessionData.isAuthenticated) {
            const FirstName = sessionData.firstName;
            const email = sessionData.email;
            setUserName(FirstName);
            setUserEmail(email);
            loadUserDetails();
            delete formErrorsForCredit["UserEmail" as keyof FormErrorsStateType];
            setFormErrorsForCredit(formErrorsForCredit);
        }
    }, []);

    const setShippingAddressSameAsBillingAddress = (isChecked: boolean) => {
        setIsShipToSameAsBillTo(isChecked);
        if (isChecked) {
            setShippingAdress(billingAdress);
            setShippingCity(billingCity);
            setShipToCountry(country);
            setShipToState(billToState);
            setShippingPhone(billingPhone);
            setShippingPostalCode(billingPostalCode);
            setShippingFax(billingFax);
            setshippingEmail(billingEmail);
        } else {
            setShippingAdress("");
            setShippingCity("");
            setShippingPhone("");
            setShippingPostalCode("");
            setShippingFax("");
            setshippingEmail("");
        }

        validateShippingOnBillingChange("BTAddress");
        validateShippingOnBillingChange("BTCity");
        validateShippingOnBillingChange("BTZipCode");
        validateShippingOnBillingChange("BTPhone");
        validateShippingOnBillingChange("BTEmail");
    };
    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };

    React.useEffect(() => {
        setIsCreditFormButtonDisabled(validateSubmitDisabled(formErrorsForCredit));
    }, [formErrorsForCredit]);

    React.useEffect(() => {
        if (country && country.states && country.states.length > 0) {
            const selectStateEl: HTMLSelectElement | null = document.querySelector('[name="BTState"]');
            if (selectStateEl) {
                validateHandlerForCredit(selectStateEl);
            }
        }
    }, [country]);

    React.useEffect(() => {
        const cloneFormErrors = { ...formErrorsForCredit };
        for (const [key, value] of Object.entries(cloneFormErrors)) {
            const element: HTMLSelectElement | HTMLInputElement | null = document.querySelector(`[name="${key}"]`);
            if (element && element.value) {
                delete cloneFormErrors[key as keyof FormErrorsStateType];
                setFormErrorsForCredit(removeKey(cloneFormErrors, key));
            }
        }
        if (sessionData.isAuthenticated) {
            loadUserDetails();
        }
    }, []);

    React.useEffect(() => {
        if (sessionData.isAuthenticated && userDatails && userDatails.length > 0) {
            setCompanyName(userDatails[0].companyName);
        }
    }, [userDatails]);

    const removeKey = (formErrorObject: FormErrorsStateType, deleteKey: string) => {
        return Object.assign(
            {},
            ...Object.entries(formErrorObject)
                .filter(([k]) => k !== deleteKey)
                .map(([k, v]) => ({ [k]: v })),
        );
    };

    const validateHandlerForCredit = (
        input: HTMLInputElement | HTMLSelectElement,
        customValidation?: CallbackType,
    ): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        if (invFlag === "Email" || invFlag === "Fax") {
            formErrorsForCredit.invEmailText = "";
            formErrorsForCredit.invFaxText = "";
            setFormErrorsForCredit(formErrorsForCredit);
            if (InvoicesBeSent === "e-mail") {
                delete formErrorsForCredit["invFaxText" as keyof FormErrorsStateType];
                setFormErrorsForCredit(formErrorsForCredit);
            }
            if (InvoicesBeSent === "fax number") {
                delete formErrorsForCredit["invEmailText" as keyof FormErrorsStateType];
                setFormErrorsForCredit(formErrorsForCredit);
            }
            setInvFlag("");
        }
        const validatorConfig = newCustomerCreditValidatorConfig[input.name as keyof ValidatorConfigType];
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);
        if (isValidate === undefined) {
            delete formErrorsForCredit[input.name as keyof FormErrorsStateType];
            setFormErrorsForCredit({ ...formErrorsForCredit });
        } else {
            if (formErrorsForCredit && input.name) {
                formErrorsForCredit[input.name as keyof FormErrorsStateType] = isValidate
                    ? isValidate.errorMsg
                    : isValidate;
            }
            setFormErrorsForCredit({ ...formErrorsForCredit });
        }

        if (!validatorConfig.required && input.value === "") {
            delete formErrorsForCredit[input.name as keyof FormErrorsStateType];
            setFormErrorsForCredit(formErrorsForCredit);
        }
        setIsCreditFormButtonDisabled(validateSubmitDisabled(formErrorsForCredit));
    };

    const onBlurCreditFormValidationHandler = (input: HTMLInputElement | HTMLSelectElement) => {
        validateHandlerForCredit(input);
    };

    const onBlurBillingFieldsValidationHandler = (input: HTMLInputElement | HTMLSelectElement) => {
        validateHandlerForCredit(input);
        if (IsShipToSameAsBilling) {
            validateShippingOnBillingChange(input.name);
        }
    };

    const validateShippingOnBillingChange = (inputName: string) => {
        switch (inputName) {
            case "BTAddress":
                validateHandlerForCredit(document.querySelector("input[name='STAdd1']") as HTMLInputElement);
                break;
            case "BTCity":
                validateHandlerForCredit(document.querySelector("input[name='STCity']") as HTMLInputElement);
                break;
            case "BTZipCode":
                validateHandlerForCredit(document.querySelector("input[name='STPc']") as HTMLInputElement);
                break;
            case "BTPhone":
                validateHandlerForCredit(document.querySelector("input[name='STPhone']") as HTMLInputElement);
                break;
            case "BTEmail":
                validateHandlerForCredit(document.querySelector("input[name='STEmail']") as HTMLInputElement);
                break;
            default:
                break;
        }
    };

    const organizationStructureHandler = (orgnizationType: string) => {
        setOrganizationStructure(orgnizationType);
    };

    const componentStyles: MessageFilterStyles = styles.messageFilter || {};

    const stateDateIncorporatedHandler = (input: HTMLInputElement) => {
        setStateDateIncorporated(input.value);
    };

    const companyOperationalTimeHandler = (input: HTMLInputElement) => {
        setCompanyOperationalTime(input.value);
        validateCompanyOperationalTime(input);
    };
    const validateCompanyOperationalTime = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim() ? companyOperationalTimeErrorMsg : "";
        setcompanyOperationalTimeError(errorMessage);
        return !errorMessage;
    };
    const principalActivityHandler = (input: HTMLInputElement) => {
        setPrincipalActivity(input.value);
        validatePrincipalActivity(input);
    };
    const validatePrincipalActivity = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim() ? principalActivityErrorMsg : "";
        setprincipalActivityError(errorMessage);
        return !errorMessage;
    };

    const isCompanyNameChangedHandler = (IsCompanyNameChanged: string) => {
        validateFormerName(IsCompanyNameChanged);
        setIsCompanyNameChanged(IsCompanyNameChanged);
        yesNoQuestionsValidationHandler(IsCompanyNameChanged, ["companyNameChanged"]);
    };

    const validateFormerName = (formerName: string) => {
        const errorMessage = !formerName.trim() ? isCompanyNameChangedErrorMsg : "";
        setFormerNamerror(errorMessage);
        return !errorMessage;
    };

    const formerNameHandler = (flag: string) => {
        validateFormerName(IsCompanyNameChanged);
        setFormerName(flag);
        yesNoQuestionsValidationHandler(IsCompanyNameChanged, ["companyNameChanged"]);
    };

    const isPastBoughtHandler = (IsPastBought: string) => {
        validatePastBuyerName(IsPastBought);
        setIsPastBought(IsPastBought);
        yesNoQuestionsValidationHandler(IsPastBought, ["pastbuyerName"]);
    };

    const validatePastBuyerName = (pastBuyerName: string) => {
        const errorMessage = !pastBuyerName.trim() ? pastBuyerNameErrorMsg : "";
        setPastBuyerNameError(errorMessage);
        return !errorMessage;
    };
    const pastBuyerNameHandler = (flag: string) => {
        validatePastBuyerName(IsPastBought);
        setPastBuyerName(flag);
        yesNoQuestionsValidationHandler(IsPastBought, ["pastbuyerName"]);
    };

    const creditLimitHandler = (limit: string) => {
        setCreditLimit(limit);
    };
    const apContactHandler = (input: HTMLInputElement) => {
        setApContact(input.value);
        validateApContact(input);
    };
    const validateApContact = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim() ? apContactErrorMsg : "";
        setApContactError(errorMessage);
        return !errorMessage;
    };
    const apContactEmailHandler = (email: string) => {
        validateApContactEmail(email);
        setApContactEmail(email);
    };
    const validateApContactEmail = (email: string) => {
        const errorMessage = !email
            ? apContactEmailRequiredFieldMessage
            : emailRegexp.test(email)
            ? ""
            : apContactEmailValidateFieldMessage;
        setApContactEmailError(errorMessage);
        return !errorMessage;
    };

    const isSalesTaxExemptHandler = (IsSalesTaxExempt: string) => {
        setIsSalesTaxExempt(IsSalesTaxExempt);
    };
    const brcNameHandler = (input: HTMLInputElement) => {
        setBrcFirstname(input.value);
        validatebrcName(input);
    };
    const validatebrcName = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim()
            ? bankNameErrorMsg
            : input.value.length < 2
            ? bankNameValidateErrorMsg
            : "";
        setBankNameError(errorMessage);
        return !errorMessage;
    };

    const brcAccountHandler = (input: HTMLInputElement) => {
        setBrcAccount(input.value);
        validateAccount(input);
    };
    const validateAccount = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim()
            ? accountErrorMsg
            : input.value.length < 2 && input.value.trim()
            ? accountValidateErrorMsg
            : "";
        setAcountError(errorMessage);
        return !errorMessage;
    };

    const brcPhoneNumberHandler = (input: HTMLInputElement) => {
        setBrcPhoneNumber(formatPhoneNumber(input.value));
        validateBrcPhone(input);
    };
    const validateBrcPhone = (input: HTMLInputElement) => {
        const errorMessage = !input.value || input.value.length <= 11 ? validPhoneMsg : "";
        setBrcPhoneError(errorMessage);
        return !errorMessage;
    };

    const brcAddressHandler = (input: HTMLInputElement) => {
        setBrcAddress(input.value);
        validateBankAddress(input);
    };
    const validateBankAddress = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim()
            ? bankAddressErrorMsg
            : input.value.length < 2
            ? bankAddressValidateErrorMsg
            : "";
        setbankAddressError(errorMessage);
        return !errorMessage;
    };

    const brcFaxHandler = (bankFax: string) => {
        setBrcFax(formatPhoneNumber(bankFax));
    };

    const businessRefCompName1Handler = (input: HTMLInputElement) => {
        setBusinessRefCompName1(input.value);
        validateRef1CompanyName(input);
    };
    const validateRef1CompanyName = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim()
            ? ref1CompanyNameErrorMsg
            : input.value.length < 2
            ? ref1CompanyNameValidateErrorMsg
            : "";
        setRef1CompanyError(errorMessage);
        return !errorMessage;
    };

    const handleShipToCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const stCountryLookup = countries!.find(c => c.id === event.currentTarget.value)!;
        setShipToCountry(stCountryLookup);
        if (!(stCountryLookup && stCountryLookup.states && stCountryLookup.states.length > 0)) {
            const stSelectedState: StateModel | undefined = undefined;
            setShipToState(stSelectedState);
        }
        // need to check that if user is changing his country then state's value should get refresh
    };
    const handleBillToCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const btCountryLookup = countries!.find(c => c.id === event.currentTarget.value)!;
        validateHandlerForCredit(event.currentTarget);
        setCountry(btCountryLookup);
        if (IsShipToSameAsBilling) {
            setShipToCountry(btCountryLookup);
        }
        if (!(btCountryLookup && btCountryLookup.states && btCountryLookup.states.length > 0)) {
            const btSelectedState: StateModel | undefined = undefined;
            setbillToState(btSelectedState);
            delete formErrorsForCredit["BTState" as keyof FormErrorsStateType];
            setFormErrorsForCredit(formErrorsForCredit);
            setIsCreditFormButtonDisabled(validateSubmitDisabled(formErrorsForCredit));
        }
        // need to check that if user is changing his country then state's value should get refresh
    };
    const handleShipToStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const stSelectedState: StateModel | undefined = shipToCountry?.states?.find(
            s => s.id === event.currentTarget.value,
        );
        setShipToState(stSelectedState);
    };
    const handleBillToStateChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const btSelectedState: StateModel | undefined = country?.states?.find(s => s.id === event.currentTarget.value);
        setbillToState(btSelectedState);
        if (IsShipToSameAsBilling) {
            setShipToState(btSelectedState);
        }
        validateHandlerForCredit(event.currentTarget);
    };

    const businessRefName1Handler = (input: HTMLInputElement) => {
        setBusinessRefName1(input.value);
        validateBusinessRefName1(input);
    };
    const validateBusinessRefName1 = (input: HTMLInputElement) => {
        const errorMessage = !input.value
            ? businessRefName1ErrorMsg
            : input.value.length < 2
            ? businessRefName1ValidateErrorMsg
            : "";
        setBusinessRefName1Error(errorMessage);
        return !errorMessage;
    };

    const businessRefTitle1Handler = (title: string) => {
        setBusinessRefTitle1(title);
    };

    const businessRefAddress1Handler = (input: HTMLInputElement) => {
        setBusinessRefAddress1(input.value);
        validatebusinessRefAddress1(input);
    };
    const validatebusinessRefAddress1 = (input: HTMLInputElement) => {
        const errorMessage = !input.value
            ? businessRefAddress1ErrorMsg
            : input.value.length < 2
            ? businessRefAddress1ValidateErrorMsg
            : "";
        setBusinessRefAddress1Error(errorMessage);
        return !errorMessage;
    };

    const businessRefPhone1Handler = (input: HTMLInputElement) => {
        setBusinessRefPhone1(formatPhoneNumber(input.value));
        // validateBusinessRefPhone1(input);
    };
    const validateBusinessRefPhone1 = (input: HTMLInputElement) => {
        const errorMessage = !input.value || input.value.length <= 11 ? validPhoneMsg : "";
        setBusinessRefPhone1Error(errorMessage);
        return !errorMessage;
    };

    const businessRefFax1Handler = (fax: string) => {
        setBusinessRefFax1(formatPhoneNumber(fax));
    };

    const businessRefEmail1Handler = (email: string) => {
        setBusinessRefEmail1(email);
        // validateBusinessRef1Email(email);
    };

    const validateBusinessRef1Email = (input: string) => {
        const errorMessage = emailRegexp.test(input)
            ? ""
            : businessRefEmailValidateFieldMessage;
        setBusinessRef1EmailEmailError(input === "" ? "": errorMessage);
        setBusinessRef1EmailEmailError(errorMessage);
        return !errorMessage;
    };

    const businessRefEmail2Handler = (email: string) => {
        setBusinessRefEmail2(email);
        // validateBusinessRef2Email(email);
    };

    const validateBusinessRef2Email = (input: string) => {
        const errorMessage = emailRegexp.test(input)
            ? ""
            : businessRefEmailValidateFieldMessage;
        setBusinessRef2EmailEmailError(input === "" ? "": errorMessage);
        return !errorMessage;
    };

    const businessRefCompName2Handler = (input: HTMLInputElement) => {
        setBusinessRefCompName2(input.value);
        validateRef2CompanyName(input);
    };
    const validateRef2CompanyName = (input: HTMLInputElement) => {
        const errorMessage = !input.value
            ? ref2CompanyNameErrorMsg
            : input.value.length < 2
            ? ref2CompanyNameValidateErrorMsg
            : "";
        setRef2CompanyError(errorMessage);
        return !errorMessage;
    };

    const businessRefName2Handler = (input: HTMLInputElement) => {
        setBusinessRefName2(input.value);
        validateBusinessRefName2(input);
    };
    const validateBusinessRefName2 = (input: HTMLInputElement) => {
        const errorMessage = !input.value
            ? businessRefName2ErrorMsg
            : input.value.length < 2
            ? businessRefName2ValidateErrorMsg
            : "";
        setBusinessRefName2Error(errorMessage);
        return !errorMessage;
    };

    const businessRefTitle2Handler = (title: string) => {
        setBusinessRefTitle2(title);
    };

    const businessRefAddress2Handler = (input: HTMLInputElement) => {
        setBusinessRefAddress2(input.value);
        validatebusinessRefAddress2(input);
    };

    const validatebusinessRefAddress2 = (input: HTMLInputElement) => {
        const errorMessage = !input.value
            ? businessRefAddress2ErrorMsg
            : input.value.length < 2
            ? businessRefAddress2ValidateErrorMsg
            : "";
        setBusinessRefAddress2Error(errorMessage);
        return !errorMessage;
    };

    const businessRefPhone2Handler = (input: HTMLInputElement) => {
        setBusinessRefPhone2(formatPhoneNumber(input.value));
        // validateBusinessRefPhone2(input);
    };
    const validateBusinessRefPhone2 = (input: HTMLInputElement) => {
        const errorMessage = !input.value || input.value.length <= 11 ? validPhoneMsg : "";
        setBusinessRefPhone2Error(errorMessage);
        return !errorMessage;
    };

    const businessRefFax2Handler = (fax: string) => {
        setBusinessRefFax2(formatPhoneNumber(fax));
    };

    const isBankruptHandler = (IsBankrupt: string) => {
        setIsBankrupt(IsBankrupt);
        yesNoQuestionsValidationHandler(IsBankrupt, ["IsBankruptText"]);
    };

    const isSuitFiledHandler = (IsSuitFiled: string) => {
        setIsSuitFiled(IsSuitFiled);
        yesNoQuestionsValidationHandler(IsSuitFiled, ["suitFiledText"]);
    };

    const isUpsAccountHandler = (IsUpsAccount: string) => {
        validateUpsAccount(upsAccount);
        setIsUpsAccount(IsUpsAccount);
        yesNoQuestionsValidationHandler(IsUpsAccount, ["shippingAccount"]);
    };
    const validateUpsAccount = (upsAccount: string) => {
        const errorMessage = !upsAccount ? upsAccountErrorMsg : "";
        setUpsAccountError(errorMessage);
        return !errorMessage;
    };

    const upsAccountHandler = (flag: string) => {
        validateUpsAccount(upsAccount);
        setUpsAccount(flag);
        yesNoQuestionsValidationHandler(IsUpsAccount, ["shippingAccount"]);
    };

    const yesNoQuestionsValidationHandler = (answer: string, fieldnames: string[]) => {
        for (const key of fieldnames) {
            const element: HTMLSelectElement | HTMLInputElement | null = document.querySelector(`[name="${key}"]`);
            if (element != null) {
                if (answer === "Yes") {
                    validateHandlerForCredit(element);
                } else {
                    validationRemoveHandler(key);
                }
            }
        }
    };

    const validationRemoveHandler = (inputName: string): void => {
        delete formErrorsForCredit[inputName as keyof FormErrorsStateType];
        setFormErrorsForCredit(formErrorsForCredit);
        setIsCreditFormButtonDisabled(validateSubmitDisabled(formErrorsForCredit));
    };

    const receivingHoursHandler = (input: HTMLInputElement) => {
        setReceivingHours(input.value);
        validatereceivingHours(input);
    };

    const validatereceivingHours = (input: HTMLInputElement) => {
        const errorMessage = !input.value ? receivingHoursErrorMsg : "";
        setReceivingHoursError(errorMessage);
        return !errorMessage;
    };

    const isTermsHandler = (input: HTMLInputElement) => {
        setIsTerms(input.value);
        validateIsTerms(input);
    };
    const validateIsTerms = (input: HTMLInputElement) => {
        const errorMessage = input.value === "Reject" ? isTermsErrorMsg : "";
        setIsTermsError(errorMessage);
        return !errorMessage;
    };

    const invFaxNumberHandler = (input: HTMLInputElement) => {
        // setInvFaxNumber(input.value);
        setInvFaxNumber(formatPhoneNumber(input.value));
        setInvFlag("Fax");
        validateInvFaxNumberText(input);
    };
    const validateInvFaxNumberText = (input: HTMLInputElement) => {
        const errorMessage = !input.value
            ? invFaxNumberTextErrorMsg
            : input.value.length <= 11
            ? invFaxNumberTextValidErrorMsg
            : "";
        setInvFaxNumberTextError(errorMessage);
        return !errorMessage;
    };

    const invEmailHandler = (input: HTMLInputElement) => {
        setInvEmail(input.value);
        setInvFlag("Email");
        validateInvEmail(input);
    };

    const validateInvEmail = (input: HTMLInputElement) => {
        const errorMessage = !input.value
            ? invEmailRequiredFieldMessage
            : emailRegexp.test(input.value)
            ? ""
            : invEmailValidateFieldMessage;
        setInvEmailEmailError(errorMessage);
        return !errorMessage;
    };

    const isBankruptTextHandler = (text: string) => {
        validateSuitFiledText(IsSuitFiled);
        validateIsBankruptText(IsBankrupt);
        setIsBankruptText(text);
        yesNoQuestionsValidationHandler(IsBankrupt, ["IsBankruptText"]);
    };

    const validateIsBankruptText = (IsBankrupt: string) => {
        const errorMessage = !IsBankrupt ? IsSuitFiledErrorMsg : "";
        setUpsAccountError(errorMessage);
        return !errorMessage;
    };

    const validateSuitFiledText = (IsSuitFiled: string) => {
        const errorMessage = !IsSuitFiled ? IsSuitFiledErrorMsg : "";
        setUpsAccountError(errorMessage);
        return !errorMessage;
    };

    const suitFiledTextHandler = (text: string) => {
        validateSuitFiledText(IsSuitFiled);
        setSuitFiledText(text);
        yesNoQuestionsValidationHandler(IsSuitFiled, ["suitFiledText"]);
    };

    const businessStartDateHandler = (input: HTMLInputElement) => {
        setBusinessStartDate(input.value);
    };
    // const shippingInfoCompanyNameHandler = (input: HTMLInputElement) => {
    //     setShippingInfoCompanyName(input.value);
    // };
    // const shippingDateHandler = ({ selectedDay }: DatePickerState) => {
    //     setShippingDate(selectedDay || new Date());
    // };
    const shippingAdressHandler = (input: HTMLInputElement) => {
        validateShippingAddressHandler(input);
        setShippingAdress(input.value);
    };
    const validateShippingAddressHandler = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim()
            ? shippingAddressErrorMsg
            : input.value.length < 5
            ? shippingAddressValidErrorMsg
            : "";
        setShippingAddressError(errorMessage);
        return !errorMessage;
    };
    const shippingCityHandler = (input: HTMLInputElement) => {
        validateShippingCity(input);
        setShippingCity(input.value);
    };
    const validateShippingCity = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim()
            ? shipToCityErrorMsg
            : input.value.length < 2
            ? shipToCityValidateErrorMsg
            : "";
        setshippingCityError(errorMessage);
        return !errorMessage;
    };

    const shippingPostalCodeHandler = (input: HTMLInputElement) => {
        validateShiToPostalCode(input);
        setShippingPostalCode(input.value);
    };
    const validateShiToPostalCode = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim()
            ? shippingPostalCodeErrorMsg
            : input.value.length < 5
            ? shippingPostalCodeValidateErrorMsg
            : "";
        setshippingPostalCodeError(errorMessage);
        return !errorMessage;
    };

    const shippingPhoneHandler = (input: HTMLInputElement) => {
        validateShippingPhone(input);
        setShippingPhone(formatPhoneNumber(input.value));
    };
    const validateShippingPhone = (input: HTMLInputElement) => {
        const errorMessage = !input.value ? phoneErrorMsg : input.value.length <= 11 ? validPhoneMsg : "";
        setShippingPhoneError(errorMessage);
        return !errorMessage;
    };
    const shippingFaxHandler = (input: HTMLInputElement) => {
        setShippingFax(formatPhoneNumber(input.value));
    };

    const shippingEmailHandler = (input: HTMLInputElement) => {
        validateShippingEmail(input.value);
        setshippingEmail(input.value);
    };
    const validateShippingEmail = (email: string) => {
        const errorMessage = !email
            ? shippingEmailRequiredFieldMessage
            : emailRegexp.test(email)
            ? ""
            : shippingEmailValidateFieldMessage;
        setShippingEmailError(errorMessage);
        return !errorMessage;
    };
    const CompanyNameHandler = (input: HTMLInputElement) => {
        setCompanyName(input.value);
    };
    const UserNameHandler = (input: HTMLInputElement) => {
        setUserName(input.value);
        validateHandlerForCredit(input);
    };
    const DateHandler = ({ selectedDay }: DatePickerState) => {
        setDate(selectedDay || new Date());
    };

    const billingAdressHandler = (input: HTMLInputElement) => {
        validateBillingAddressHandler(input);
        setBillingAdress(input.value);
        if (IsShipToSameAsBilling) {
            setShippingAdress(input.value);
        }
    };
    const validateBillingAddressHandler = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim()
            ? billingAddressErrorMsg
            : input.value.length < 5
            ? billingAddresslengthErrorMsg
            : "";
        setBillingAddressError(errorMessage);
        return !errorMessage;
    };
    const billingCityHandler = (input: HTMLInputElement) => {
        validateBillingCity(input);
        setBillingCity(input.value);
        if (IsShipToSameAsBilling) {
            setShippingCity(input.value);
        }
    };
    const validateBillingCity = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim()
            ? billTocityErrorMsg
            : input.value.length < 2
            ? billToCityValidateErrorMsg
            : "";
        setBillingCityError(errorMessage);
        return !errorMessage;
    };
    const billingPostalCodeHandler = (input: HTMLInputElement) => {
        validateBillToPostalCode(input);
        setBillingPostalCode(input.value);
        if (IsShipToSameAsBilling) {
            setShippingPostalCode(input.value);
        }
    };
    const validateBillToPostalCode = (input: HTMLInputElement) => {
        const errorMessage = !input.value.trim()
            ? billingPostalCodeErrorMsg
            : input.value.length < 5
            ? billingPostalCodeValidateErrorMsg
            : "";
        setBillingPostalCodeError(errorMessage);
        return !errorMessage;
    };

    const billingPhoneHandler = (value: string) => {
        validatePhone(value);
        setBillingPhone(formatPhoneNumber(value));
        if (IsShipToSameAsBilling) {
            setShippingPhone(formatPhoneNumber(value));
        }
    };
    const validatePhone = (value: string) => {
        const errorMessage = !value ? phoneErrorMsg : value.length <= 11 ? validPhoneMsg : "";
        setBillingPhoneError(errorMessage);
        return !errorMessage;
    };
    const billingFaxHandler = (input: HTMLInputElement) => {
        setBillingFax(formatPhoneNumber(input.value));
        if (IsShipToSameAsBilling) {
            setShippingFax(input.value);
        }
    };

    const billingEmailHandler = (input: HTMLInputElement) => {
        validateBillingEmail(input.value);
        setBillingEmail(input.value);
        if (IsShipToSameAsBilling) {
            setshippingEmail(input.value);
        }
    };
    const validateBillingEmail = (email: string) => {
        const errorMessage = !email
            ? shippingEmailRequiredFieldMessage
            : emailRegexp.test(email)
            ? ""
            : billingEmailValidateFieldMessage;
        setBillingEmailError(errorMessage);
        return !errorMessage;
    };
    const userEmailHandler = (input: HTMLInputElement) => {
        validateEmail(input);
        setUserEmail(input.value);
    };

    const scrollToFirstFormError = () => {
        const firstErrorElement = document.querySelector("[aria-invalid='true']");
        if (firstErrorElement) {
            const formFieldParent = firstErrorElement.closest("[class*='FormFieldStyle']");
            if (!formFieldParent) {
                return;
            }
            const { top } = formFieldParent.getBoundingClientRect();
            formFieldParent.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
    };

    const validateSubmitEnabled = () => {
        let submitEnable = true;
        if (
            billingAddressError ||
            billingCityError ||
            billingPostalCodeError ||
            billingPhoneError ||
            bankNameError ||
            bankAccountError ||
            bankAddressError ||
            brcPhoneError ||
            Ref1companyError ||
            Ref2companyError ||
            businessRefName1Error ||
            businessRefName2Error ||
            businessRefAddress1Error ||
            businessRefAddress2Error ||
            // businessRefPhone1Error ||
            // businessRefPhone2Error ||
            companyOperationalTimeError ||
            invEmailError ||
            principalActivityError ||
            receivingHoursError ||
            apContactError ||
            apContactEmailError ||
            isTermsError 
            // businessRef1EmailError ||
            // businessRef2EmailError
        ) {
            submitEnable = false;
        }
        if (!IsShipToSameAsBilling) {
            if (
                shippingCityError ||
                shippingPostalCodeError ||
                shippingPhoneError ||
                shippingAddressError ||
                shippingEmailError
            ) {
                submitEnable = false;
            }
        }
        return submitEnable;
    };

    const submitHandler = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();

        const isCaptchaValid = await validateReCaptcha({ location: "ContactUs", recaptchaRef  });
        if (!isCaptchaValid) {
            return;
        }

        if (!isSubmitted) {
            setIsSubmitted(true);
        }

        if (!validateSubmitEnabled()) {
            setFormErrorsForCredit(formErrorsForCredit);
            setTimeout(() => {
                scrollToFirstFormError();
            }, 50);
            return false;
        }

        const addCreditApplicationParams: CreditApplicationFormModel = {
            type: "CreditApplication",
            Company: CompanyName,
            UserName,
            UserEmail: userEmail,
            Date: billingDate,
            BTAdd1: billingAdress,
            BTCity: billingCity,
            BTPc: billingPostalCode,
            BTState: billToState?.name,
            BTCountry: country?.name,
            BTPhone: billingPhone,
            BTFax: billingFax,
            BTEmail: billingEmail,
            STAdd1: shippingAdress,
            STCity: shippingCity,
            STPc: shippingPostalCode,
            STPhone: shippingPhone,
            STFax: shippingFax,
            STEmail: shippingEmail,
            STCountry: shipToCountry?.name,
            STState: shipToState?.name,
            BusinessStartDate: businessStartDate,
            OrganizationStructure: organizationStructure,
            StateDateIncorporated: stateDateIncorporated,
            CompanyOperationalTime: companyOperationalTime,
            PrincipalActivity: principalActivity,
            FormerName: formerName,
            PastBuyerName: pastBuyerName,
            CreditLimit: creditLimit,
            IsSalesTaxExempt,
            ApContact: apContact,
            ApContactEmail: apContactEmail,
            InvoiceSentEmail: invEmailText,
            InvoiceSentFaxNum: invFaxNumberText,
            InvoiceSentUsPostMail: invUSPostalMail,
            BankName: bankName,
            BankAccount: bankAccount,
            BankAddress: bankAddress,
            BankPhone: bankPhone,
            BankFax: bankFax,
            BusinessRefCompName1: businessRefCompName1,
            BusinessRefName1: businessRefName1,
            BusinessRefTitle1: businessRefTitle1,
            BusinessRefAddress1: businessRefAddress1,
            BusinessRefPhone1: businessRefPhone1,
            BusinessRefFax1: businessRefFax1,
            BusinessRefCompName2: businessRefCompName2,
            BusinessRefName2: businessRefName2,
            BusinessRefTitle2: businessRefTitle2,
            BusinessRefAddress2: businessRefAddress2,
            BusinessRefPhone2: businessRefPhone2,
            BusinessRefFax2: businessRefFax2,
            BankruptText: IsBankruptText,
            SuitFiledText: suitFiledText,
            UpsAccount: upsAccount,
            ReceivingHours: receivingHours,
            IsTerms,
            IsCompanyNameChanged,
            IsPastBought,
            IsBankrupt,
            IsSuitFiled,
            BusinessRefEmail1:businessRefEmail1,
            BusinessRefEmail2: businessRefEmail2
            
        };
        addCreditApplicationFormFields({
            addCreditApplicationParams,
            onSuccess: () => {
                clearForm();
                window.location.href = "/ThankYou";
            },
        });
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.subHeading}>
                There are two options below for submitting your credit application.
            </StyledWrapper>
            <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                <StyledWrapper
                    {...CreateAccountExistingFormStyles.paddingBottom}
                    {...CreateAccountExistingFormStyles.customFlexBox}
                >
                    <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                        <StyledWrapper {...styles.centerAlignFlexbox}>
                            <StyledWrapper {...CreateAccountExistingFormStyles.tenPerWidth} {...styles.formStepsNumber}>
                                {" "}
                                1{" "}
                            </StyledWrapper>
                            <StyledWrapper {...CreateAccountExistingFormStyles.ninetyPerWidth}>
                                <Typography as="p" {...styles.formStepsHeading}>
                                    ONLINE
                                </Typography>
                                <Typography as="p">Thank you for choosing Cooney Brothers, LLC</Typography>
                                <Typography as="p">Please fill in the online application form below</Typography>
                                <Typography as="p" {...styles.CreateAccountExistingFormStyles}>
                                    <StyledSpan {...CreateAccountExistingFormStyles.errorColor}>*</StyledSpan> Indicates
                                    a required field
                                </Typography>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                    <StyledWrapper {...CreateAccountExistingFormStyles.seventyPerWidth}>
                        <StyledWrapper {...styles.centerAlignFlexbox}>
                            <StyledWrapper {...CreateAccountExistingFormStyles.tenPerWidth} {...styles.formStepsNumber}>
                                {" "}
                                2{" "}
                            </StyledWrapper>
                            <StyledWrapper {...CreateAccountExistingFormStyles.ninetyPerWidth}>
                                <Typography as="p" {...styles.formStepsHeading}>
                                    OFFLINE
                                </Typography>
                                <Typography as="p">
                                    Download the PDF credit application and send it to our accounting department by email at 
                                     <a title="mailto:ecommerce@cooneybrothers.com" href="mailto:ecommerce@cooneybrothers.com" style={{display: 'inline-block', color: '#EF3742',fontWeight: "600", padding:"0px 5px"}}  >ecommerce@cooneybrothers.com</a> 
                                      or by fax at (610) 279-8618. Your account status will be available within 3 business days of receiving your application.{" "}
                                    <Link
                                        target="new"
                                        href="/userfiles/files/creditapplication.pdf"
                                        {...styles.underline}
                                    >
                                        Download the Credit Application
                                    </Link>
                                </Typography>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </GridContainer>
            <StyledWrapper>
                <StyledWrapper {...styles.halfWidthCustomInputCss}>
                    <TextField
                        {...styles.userNameTextField}
                        label={translate("Company Name")}
                        value={CompanyName}
                        onChange={e => CompanyNameHandler(e.currentTarget)}
                    />
                </StyledWrapper>
                <StyledWrapper {...styles.halfWidthDatePickerCss}>
                    <DatePicker
                        {...styles.startDatePicker}
                        label={translate("Date *")}
                        // selectedDay={new Date()}
                        selectedDay={billingDate}
                        onDayChange={DateHandler}
                    />
                </StyledWrapper>
                <StyledWrapper {...styles.halfWidthCustomInputCss}>
                    <TextField
                        {...styles.userNameTextField}
                        label={translate("Name")}
                        value={UserName}
                        data-test-selector="rfq_firstName"
                        onChange={e => UserNameHandler(e.currentTarget)}
                    />
                </StyledWrapper>
                <StyledWrapper {...styles.halfWidthCustomInputCss1}>
                    <TextField
                        {...styles.userNameTextField}
                        label={translate("Email *")}
                        value={userEmail}
                        data-test-selector="rfq_email"
                        onChange={e => userEmailHandler(e.currentTarget)}
                        error={
                            isSubmitted && (!userEmail || !emailRegexp.test(userEmail))
                                ? !userEmail
                                    ? emailRequiredFieldMessage
                                    : emailFieldMessage
                                : ""
                        }
                        name="UserEmail"
                    />
                </StyledWrapper>
                <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>Billing Address</StyledWrapper>
                <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                    <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                Billing Information
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <StyledWrapper {...styles.inputWithLenthyLabelCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Billing Address *")}
                                    value={billingAdress}
                                    onChange={e => billingAdressHandler(e.currentTarget)}
                                    error={isSubmitted && billingAddressError}
                                    name="BTAddress"
                                />
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("City *")}
                                    value={billingCity}
                                    onChange={e => billingCityHandler(e.currentTarget)}
                                    error={isSubmitted && billingCityError}
                                    name="BTCity"
                                />
                            </StyledWrapper>
                            {country && country.states && country.states.length > 0 && (
                                <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                    <Select
                                        {...styles.departmentSelect}
                                        label={translate("State")}
                                        value={
                                            billToState && billToState.id
                                            // (country && country.states && country.states[0] && country.states[0].id)
                                        }
                                        labelPosition="top"
                                        onChange={e => handleBillToStateChange(e)}
                                        onBlur={e => onBlurBillingFieldsValidationHandler(e.currentTarget)}
                                        error={!!formErrorsForCredit.BTState && formErrorsForCredit.BTState}
                                        iconProps={{
                                            color: "danger",
                                            src: formErrorsForCredit.BTState ? AlertTriangle : undefined,
                                        }}
                                        name="BTState"
                                        required
                                    >
                                        <option value="">{translate("Select State")}</option>
                                        {country.states.map(btState => (
                                            <option key={btState.id} value={btState.id}>
                                                {btState.name}
                                            </option>
                                        ))}
                                    </Select>
                                </StyledWrapper>
                            )}
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Zip/Postal Code *")}
                                    value={billingPostalCode}
                                    onChange={e => billingPostalCodeHandler(e.currentTarget)}
                                    error={isSubmitted && billingPostalCodeError}
                                    name="BTZipCode"
                                />
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <Select
                                    {...styles.departmentSelect}
                                    label={translate("Country")}
                                    value={country && country.id}
                                    labelPosition="top"
                                    onChange={e => handleBillToCountryChange(e)}
                                    onBlur={e => onBlurBillingFieldsValidationHandler(e.currentTarget)}
                                    error={!!formErrorsForCredit.BTCountry && formErrorsForCredit.BTCountry}
                                    name="BTCountry"
                                    required
                                >
                                    {countries &&
                                        countries?.map(country => (
                                            <option key={country.id} value={country.id}>
                                                {country.name}
                                            </option>
                                        ))}
                                </Select>
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Phone *")}
                                    autoComplete="autocomplete_off_randString"
                                    value={billingPhone}
                                    onChange={e => billingPhoneHandler(e.currentTarget.value)}
                                    error={isSubmitted && billingPhoneError}
                                    name="BTPhone"
                                />
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Fax#")}
                                    value={billingFax}
                                    onChange={e => billingFaxHandler(e.currentTarget)}
                                />
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    type="email"
                                    label={translate("Email *")}
                                    value={billingEmail}
                                    onChange={e => billingEmailHandler(e.currentTarget)}
                                    error={isSubmitted && billingEmailError}
                                    name="BTEmail"
                                />
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
                <StyledWrapper {...CreateAccountNewFormStyles.shipToBillToCheck}>
                    <CheckboxGroup {...CreateAccountNewFormStyles.checkboxAlignment}>
                        <Checkbox
                            onChange={(e, value) => setShippingAddressSameAsBillingAddress(value)}
                            checked={IsShipToSameAsBilling}
                            data-test-selector="createAccount_Subscription"
                        >
                            Ship to same as Bill to
                        </Checkbox>
                    </CheckboxGroup>
                </StyledWrapper>
                <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>Shipping Address</StyledWrapper>
                <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                    <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                Shipping Information
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <StyledWrapper {...styles.inputWithLenthyLabelCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Shipping Address *")}
                                    value={shippingAdress}
                                    onChange={e => shippingAdressHandler(e.currentTarget)}
                                    error={
                                        isSubmitted && !shippingAdress
                                            ? shippingAddressErrorMsg
                                            : isSubmitted && shippingAdress.length < 5
                                            ? shippingAddressValidErrorMsg
                                            : ""
                                    }
                                    name="STAdd1"
                                />
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("City *")}
                                    value={shippingCity}
                                    onChange={e => shippingCityHandler(e.currentTarget)}
                                    error={
                                        isSubmitted && !shippingCity
                                            ? shipToCityErrorMsg
                                            : isSubmitted && shippingCity.length < 2
                                            ? shipToCityValidateErrorMsg
                                            : ""
                                    }
                                    name="STCity"
                                />
                            </StyledWrapper>
                            {shipToCountry && shipToCountry.states && shipToCountry.states.length > 0 && (
                                <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                    <Select
                                        {...styles.departmentSelect}
                                        label={translate("State")}
                                        value={shipToState && shipToState.id}
                                        labelPosition="top"
                                        onChange={e => handleShipToStateChange(e)}
                                        name="STState"
                                        required
                                    >
                                        <option value="">{translate("Select State")}</option>
                                        {shipToCountry.states.map(stState => (
                                            <option key={stState.id} value={stState.id}>
                                                {stState.name}
                                            </option>
                                        ))}
                                    </Select>
                                </StyledWrapper>
                            )}
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Zip/Postal Code *")}
                                    value={shippingPostalCode}
                                    onChange={e => shippingPostalCodeHandler(e.currentTarget)}
                                    error={
                                        isSubmitted && !shippingPostalCode
                                            ? shippingPostalCodeErrorMsg
                                            : isSubmitted && shippingPostalCode.length < 5
                                            ? shippingPostalCodeValidateErrorMsg
                                            : ""
                                    }
                                    name="STPc"
                                />
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <Select
                                    {...styles.departmentSelect}
                                    label={translate("Country")}
                                    value={shipToCountry && shipToCountry.id}
                                    labelPosition="top"
                                    onChange={e => handleShipToCountryChange(e)}
                                    onBlur={e => onBlurCreditFormValidationHandler(e.currentTarget)}
                                    error={!!formErrorsForCredit.STCountry && formErrorsForCredit.STCountry}
                                    name="STCountry"
                                    required
                                >
                                    {countries &&
                                        countries?.map(stCountry => (
                                            <option key={stCountry.id} value={stCountry.id}>
                                                {stCountry.name}
                                            </option>
                                        ))}
                                </Select>
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Phone *")}
                                    autoComplete="autocomplete_off_randString"
                                    value={shippingPhone}
                                    onChange={e => shippingPhoneHandler(e.currentTarget)}
                                    error={
                                        isSubmitted && !shippingPhone
                                            ? shippingPhoneError
                                            : isSubmitted && shippingPhone.length <= 11
                                            ? validPhoneMsg
                                            : ""
                                    }
                                    name="STPhone"
                                />
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Fax#")}
                                    value={shippingFax}
                                    onChange={e => shippingFaxHandler(e.currentTarget)}
                                />
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    {...styles.userNameTextField}
                                    type="email"
                                    label={translate("Email *")}
                                    value={shippingEmail}
                                    onChange={e => shippingEmailHandler(e.currentTarget)}
                                    error={
                                        isSubmitted && (!shippingEmail || !emailRegexp.test(shippingEmail))
                                            ? !shippingEmail
                                                ? shippingEmailRequiredFieldMessage
                                                : shippingEmailValidateFieldMessage
                                            : ""
                                    }
                                    name="STEmail"
                                />
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>

                <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>Company Information</StyledWrapper>
                <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                    <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                Organization Structure
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <RadioGroup
                                {...componentStyles.radioGroup}
                                value={organizationStructure}
                                onChangeHandler={(event: any) => organizationStructureHandler(event.target.value)}
                            >
                                <Radio {...componentStyles.radioButton} key="Corporation">
                                    {translate("Corporation")}
                                </Radio>
                                <Radio {...componentStyles.radioButton} key="Partnership">
                                    {translate("Partnership")}
                                </Radio>
                                <Radio {...componentStyles.radioButton} key="Individual">
                                    {translate("Individual")}
                                </Radio>
                            </RadioGroup>
                            <StyledWrapper
                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                {...CreateAccountExistingFormStyles.fullWidth}
                            >
                                <StyledWrapper {...styles.halfWidthDatePickerCss}>
                                    <TextField
                                        {...styles.startDatePicker}
                                        label={translate("Business Start Date")}
                                        value={businessStartDate}
                                        onChange={e => businessStartDateHandler(e.currentTarget)}
                                    />
                                    {/* <DatePicker
                                        {...styles.startDatePicker}
                                        label={translate("Business Start Date")}
                                        selectedDay={businessStartDate}
                                        onDayChange={businessStartDateHandler}
                                        required
                                    /> */}
                                </StyledWrapper>
                                <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("State/Date Incorporated")}
                                        value={stateDateIncorporated}
                                        onChange={e => stateDateIncorporatedHandler(e.currentTarget)}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.inputWithLenthyLabelCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("How long has company operated at the above address? *")}
                                        value={companyOperationalTime}
                                        onChange={e => companyOperationalTimeHandler(e.currentTarget)}
                                        error={isSubmitted && companyOperationalTimeError}
                                        name="companyOperationalTime"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.inputWithLenthyLabelCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("What is the principal activity of the business? *")}
                                        value={principalActivity}
                                        onChange={e => principalActivityHandler(e.currentTarget)}
                                        error={isSubmitted && principalActivityError}
                                        name="principalActivity"
                                    />
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                Has the company ever bought from us in the past?
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <RadioGroup
                                {...componentStyles.radioGroup}
                                {...CreateAccountExistingFormStyles.inlineBlock}
                                value={IsPastBought}
                                onChangeHandler={(event: any) => isPastBoughtHandler(event.target.value)}
                            >
                                <Radio {...componentStyles.radioButton} key="Yes" value="Yes">
                                    {translate("Yes")}
                                </Radio>
                                <Radio {...componentStyles.radioButton} key="No" value="No">
                                    {translate("No")}
                                </Radio>
                            </RadioGroup>
                            <Typography {...CreateAccountExistingFormStyles.inlineBlock}>
                                (If yes please fill the below details){" "}
                            </Typography>
                            <StyledWrapper
                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                {...CreateAccountExistingFormStyles.fullWidth}
                            >
                                <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("If so, under what name")}
                                        value={pastBuyerName}
                                        onChange={e => pastBuyerNameHandler(e.currentTarget.value)}
                                        required={IsPastBought === "Yes"}
                                        error={IsPastBought === "Yes" && !pastBuyerName ? pastBuyerNameErrorMsg : ""}
                                        name="pastbuyerName"
                                    />
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                Has the company name or partnership changed in the past 5 years?
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <StyledWrapper>
                                <RadioGroup
                                    {...componentStyles.radioGroup}
                                    {...styles.radioWithFlex}
                                    value={IsCompanyNameChanged}
                                    onChangeHandler={(event: any) => isCompanyNameChangedHandler(event.target.value)}
                                >
                                    <Radio {...componentStyles.radioButton} key="Yes" value="Yes">
                                        {translate("Yes")}
                                    </Radio>
                                    <Radio {...componentStyles.radioButton} key="No" value="No">
                                        {translate("No")}
                                    </Radio>
                                </RadioGroup>
                            </StyledWrapper>
                            <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                <TextField
                                    label={translate("If so give former name")}
                                    value={formerName}
                                    onChange={e => formerNameHandler(e.currentTarget.value)}
                                    required={IsCompanyNameChanged === "Yes"}
                                    error={
                                        IsCompanyNameChanged === "Yes" && !formerName
                                            ? isCompanyNameChangedErrorMsg
                                            : ""
                                    }
                                    name="companyNameChanged"
                                />
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                Are you Sales Tax Exempt?
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <RadioGroup
                                {...componentStyles.radioGroup}
                                {...CreateAccountExistingFormStyles.inlineBlock}
                                value={IsSalesTaxExempt}
                                onChangeHandler={(event: any) => isSalesTaxExemptHandler(event.target.value)}
                            >
                                <Radio {...componentStyles.radioButton} key="Yes" value="Yes">
                                    {translate("Yes")}
                                </Radio>
                                <Radio {...componentStyles.radioButton} key="No" value="No">
                                    {translate("No")}
                                </Radio>
                            </RadioGroup>
                            <Typography as="p" {...CreateAccountExistingFormStyles.inlineBlock}>
                                (If yes, please email exemption certificate to{" "}
                                <Link target="_blank" href="mailto:ar@cooneybrothers.com">
                                ar@cooneybrothers.com
                                </Link>
                                )
                            </Typography>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                            Accounting Contact
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <StyledWrapper
                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                {...CreateAccountExistingFormStyles.fullWidth}
                            >
                                <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("A/P Contact *")}
                                        value={apContact}
                                        onChange={e => apContactHandler(e.currentTarget)}
                                        error={isSubmitted && apContactError}
                                        name="apContact"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.halfWidthCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("A/P Contact Email *")}
                                        value={apContactEmail}
                                        onChange={e => apContactEmailHandler(e.currentTarget.value)}
                                        error={isSubmitted && apContactEmailError}
                                        name="ApContactEmail"
                                    />
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem {...styles.userNameGridItem} {...styles.creditApplicationLastDiv}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                            To what email address should invoices be sent?
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <StyledWrapper
                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                {...CreateAccountExistingFormStyles.fullWidth}
                            >
                                <StyledWrapper
                                    {...styles.halfWidthCustomInputCss}
                                    style={{ display: InvoicesBeSent === "e-mail" ? "block" : "none" }}
                                >
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Invoice Email")}
                                        value={invEmailText}
                                        onChange={e => invEmailHandler(e.currentTarget)}
                                        required={InvoicesBeSent === "e-mail"}
                                        error={isSubmitted && invEmailError}
                                        name={InvoicesBeSent === "e-mail" ? "invEmailText" : ""}
                                    />
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper {...CreateAccountExistingFormStyles.fullWidth}>
                <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                    Bank Reference (Checking)
                </StyledWrapper>
                <StyledWrapper
                    {...CreateAccountExistingFormStyles.customInputCss}
                    className="fullWidthForMobileDevices"
                >
                    <TextField
                        {...styles.userNameTextField}
                        label={translate("Bank Name *")}
                        value={bankName}
                        onChange={e => brcNameHandler(e.currentTarget)}
                        error={isSubmitted && bankNameError}
                        name="bankName"
                    />
                </StyledWrapper>
                <StyledWrapper
                    {...CreateAccountExistingFormStyles.customInputCss}
                    className="fullWidthForMobileDevices"
                >
                    <TextField
                        {...styles.userNameTextField}
                        label={translate("Account# *")}
                        value={bankAccount}
                        onChange={e => brcAccountHandler(e.currentTarget)}
                        error={isSubmitted && bankAccountError}
                        name="bankAccount"
                    />
                </StyledWrapper>
                <StyledWrapper
                    {...CreateAccountExistingFormStyles.customInputCss}
                    className="fullWidthForMobileDevices"
                >
                    <TextField
                        {...styles.userNameTextField}
                        label={translate("Address *")}
                        value={bankAddress}
                        onChange={e => brcAddressHandler(e.currentTarget)}
                        error={isSubmitted && bankAddressError}
                        name="bankAddress"
                    />
                </StyledWrapper>
                <StyledWrapper
                    {...CreateAccountExistingFormStyles.customInputCss}
                    className="fullWidthForMobileDevices"
                >
                    <TextField
                        {...styles.userNameTextField}
                        label={translate("Phone Number *")}
                        value={bankPhone}
                        onChange={e => brcPhoneNumberHandler(e.currentTarget)}
                        error={isSubmitted && brcPhoneError}
                        name="bankPhone"
                    />
                </StyledWrapper>
                <StyledWrapper
                    {...CreateAccountExistingFormStyles.customInputCss}
                    className="fullWidthForMobileDevices"
                >
                    <TextField
                        {...styles.userNameTextField}
                        label={translate("Fax#")}
                        value={bankFax}
                        onChange={e => brcFaxHandler(e.currentTarget.value)}
                    />
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper>
                <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                    Business Reference (Where credit is now extended)
                </StyledWrapper>
                <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                    <StyledWrapper {...CreateAccountExistingFormStyles.customFlexBox}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                            <StyledWrapper
                                {...CreateAccountExistingFormStyles.customInputCss}
                                {...CreateAccountExistingFormStyles.fullWidth}
                            >
                                <StyledWrapper>
                                    <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                        Reference 1:
                                    </Typography>
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Company Name *")}
                                        value={businessRefCompName1}
                                        onChange={e => businessRefCompName1Handler(e.currentTarget)}
                                        error={isSubmitted && Ref1companyError}
                                        name="businessRefCompName1"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Name *")}
                                        value={businessRefName1}
                                        onChange={e => businessRefName1Handler(e.currentTarget)}
                                        error={isSubmitted && businessRefName1Error}
                                        name="businessRefName1"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Title")}
                                        value={businessRefTitle1}
                                        onChange={e => businessRefTitle1Handler(e.currentTarget.value)}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Address *")}
                                        value={businessRefAddress1}
                                        onChange={e => businessRefAddress1Handler(e.currentTarget)}
                                        error={isSubmitted && businessRefAddress1Error}
                                        name="businessRefAddress1"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Phone")}
                                        autoComplete="autocomplete_off_randString"
                                        value={businessRefPhone1}
                                        onChange={e => businessRefPhone1Handler(e.currentTarget)}
                                        // error={isSubmitted && businessRefPhone1Error}
                                        name="businessRefPhone1"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Fax#")}
                                        value={businessRefFax1}
                                        onChange={e => businessRefFax1Handler(e.currentTarget.value)}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Email")}
                                        value={businessRefEmail1}
                                        onChange={e => businessRefEmail1Handler(e.currentTarget.value)}
                                        error={isSubmitted && businessRef1EmailError}
                                    />
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fourtyEightflexWidth}>
                            <StyledWrapper
                                {...CreateAccountExistingFormStyles.customInputCss}
                                {...CreateAccountExistingFormStyles.fullWidth}
                            >
                                <StyledWrapper>
                                    <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                        Reference 2:
                                    </Typography>
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Company Name *")}
                                        value={businessRefCompName2}
                                        onChange={e => businessRefCompName2Handler(e.currentTarget)}
                                        error={isSubmitted && Ref2companyError}
                                        name="businessRefCompName2"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Name *")}
                                        value={businessRefName2}
                                        onChange={e => businessRefName2Handler(e.currentTarget)}
                                        error={isSubmitted && businessRefName2Error}
                                        name="businessRefName2"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Title")}
                                        value={businessRefTitle2}
                                        onChange={e => businessRefTitle2Handler(e.currentTarget.value)}
                                        // error={isSubmitted}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Address *")}
                                        value={businessRefAddress2}
                                        onChange={e => businessRefAddress2Handler(e.currentTarget)}
                                        error={isSubmitted && businessRefAddress2Error}
                                        name="businessRefAddress2"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Phone")}
                                        autoComplete="autocomplete_off_randString"
                                        value={businessRefPhone2}
                                        // error={isSubmitted && businessRefPhone2Error}
                                        onChange={e => businessRefPhone2Handler(e.currentTarget)}
                                        name="businessRefPhone2"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Fax#")}
                                        value={businessRefFax2}
                                        onChange={e => businessRefFax2Handler(e.currentTarget.value)}
                                        // error={isSubmitted}
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.refCustomInputCss}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Email")}
                                        value={businessRefEmail2}
                                        onChange={e => businessRefEmail2Handler(e.currentTarget.value)}
                                        error={isSubmitted && businessRef2EmailError}
                                    />
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                </GridContainer>
                <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                    <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fullWidth}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                Has applicant or any of its Owners, Principals, Partners, Officers, or Directors ever
                                filed a voluntary petition in bankruptcy, been adjudged bankrupt, or made an assignment
                                for the benefit of creditors?
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <RadioGroup
                                {...componentStyles.radioGroup}
                                value={IsBankrupt}
                                onChangeHandler={(event: any) => isBankruptHandler(event.target.value)}
                            >
                                <Radio {...componentStyles.radioButton} key="Yes" value="Yes">
                                    {translate("Yes")}
                                </Radio>
                                <Radio {...componentStyles.radioButton} key="No" value="No">
                                    {translate("No")}
                                </Radio>
                            </RadioGroup>
                            <StyledWrapper
                                {...styles.halfWidthCustomInputCss}
                                style={{ display: IsBankrupt === "Yes" ? "block" : "none" }}
                            >
                                <TextField
                                    label={translate("Please explain:")}
                                    {...styles.userNameTextField}
                                    value={IsBankruptText}
                                    onChange={e => isBankruptTextHandler(e.currentTarget.value)}
                                    required={IsBankrupt === "Yes"}
                                    error={IsBankrupt === "Yes" && !IsBankruptText ? IsSuitFiledErrorMsg : ""}
                                    name="IsBankruptText"
                                />
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                    <GridItem {...styles.userNameGridItem} {...styles.creditApplicationLastDiv}>
                        <StyledWrapper {...CreateAccountExistingFormStyles.fullWidth}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                Has a tax lien or civil suit been filed against Applicant, or any of its Owners,
                                Principals, Partners or Directors within the last 6 years?
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <RadioGroup
                                {...componentStyles.radioGroup}
                                value={IsSuitFiled}
                                onChangeHandler={(event: any) => isSuitFiledHandler(event.target.value)}
                            >
                                <Radio {...componentStyles.radioButton} key="Yes" value="Yes">
                                    {translate("Yes")}
                                </Radio>
                                <Radio {...componentStyles.radioButton} key="No" value="No">
                                    {translate("No")}
                                </Radio>
                            </RadioGroup>
                            <StyledWrapper
                                {...styles.halfWidthCustomInputCss}
                                style={{ display: IsSuitFiled === "Yes" ? "block" : "none" }}
                            >
                                <TextField
                                    label={translate("Please explain:")}
                                    {...styles.userNameTextField}
                                    value={suitFiledText}
                                    onChange={e => suitFiledTextHandler(e.currentTarget.value)}
                                    required={IsSuitFiled === "Yes"}
                                    error={IsSuitFiled === "Yes" && !suitFiledText ? IsSuitFiledErrorMsg : ""}
                                    name="suitFiledText"
                                />
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper>
                <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>
                    Shipping And Receiving
                </StyledWrapper>
                <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                    <GridItem {...styles.oneFourthGridItem}>
                        <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                            Do you have a UPS or FedEx account # to be used for shipping?
                        </Typography>
                    </GridItem>
                    <GridItem {...styles.thirdFourthGridItem}>
                        <StyledWrapper
                            {...CreateAccountExistingFormStyles.pdLeftRight}
                            {...CreateAccountExistingFormStyles.fullWidth}
                        >
                            <RadioGroup
                                {...componentStyles.radioGroup}
                                {...CreateAccountExistingFormStyles.inlineBlock}
                                value={IsUpsAccount}
                                onChangeHandler={(event: any) => isUpsAccountHandler(event.target.value)}
                            >
                                <Radio {...componentStyles.radioButton} key="Yes">
                                    {translate("Yes")}
                                </Radio>
                                <Radio {...componentStyles.radioButton} key="No">
                                    {translate("No")}
                                </Radio>
                            </RadioGroup>
                            <Typography {...CreateAccountExistingFormStyles.inlineBlock}>
                                {translate("(If yes, please fill in the Account number below.)")}
                            </Typography>
                            <StyledWrapper {...styles.columnLayout}>
                                <StyledWrapper {...styles.fullWidthInput}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("Account")}
                                        value={upsAccount}
                                        onChange={e => upsAccountHandler(e.currentTarget.value)}
                                        required={IsUpsAccount === "Yes"}
                                        error={IsUpsAccount === "Yes" && !upsAccount ? upsAccountError : ""}
                                        name="shippingAccount"
                                    />
                                </StyledWrapper>
                                <StyledWrapper {...styles.fullWidthInput}>
                                    <TextField
                                        {...styles.userNameTextField}
                                        label={translate("What are your receiving hours? *")}
                                        value={receivingHours}
                                        onChange={e => receivingHoursHandler(e.currentTarget)}
                                        error={isSubmitted && receivingHoursError}
                                        name="receivingHours"
                                    />
                                </StyledWrapper>
                            </StyledWrapper>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper {...styles.marginBottom}>
                <StyledWrapper {...CreateAccountExistingFormStyles.sectionHeading}>Credit Information</StyledWrapper>
                <GridContainer {...CreateAccountExistingFormStyles.customGridOffest}>
                    <GridItem {...styles.userNameGridItem} {...styles.sectionDivider}>
                        <GridItem {...styles.oneFourthGridItem}>
                            <Typography {...styles.attributeTypeText} {...styles.sectionLabel}>
                                Terms: 1% 10 Days; Net 30 Days. We understand your terms and agree to abide by them. *
                            </Typography>
                        </GridItem>
                        <GridItem {...styles.thirdFourthGridItem}>
                            <StyledWrapper
                                {...CreateAccountExistingFormStyles.pdLeftRight}
                                {...CreateAccountExistingFormStyles.fullWidth}
                            >
                                <RadioGroup
                                    {...componentStyles.radioGroup}
                                    {...CreateAccountExistingFormStyles.inlineBlock}
                                    value={IsTerms}
                                    onChangeHandler={(event: any) => isTermsHandler(event.target)}
                                    error={
                                        IsTerms === "Reject"
                                            ? isTermsError
                                            : isSubmitted && !IsTerms
                                            ? isTermsError
                                            : ""
                                    }
                                    name="IsTerms"
                                >
                                    <Radio {...componentStyles.radioButton} key="Accept">
                                        {translate("Accept")}
                                    </Radio>
                                    <Radio {...componentStyles.radioButton} key="Reject">
                                        {translate("Reject")}
                                    </Radio>
                                </RadioGroup>
                            </StyledWrapper>
                            <StyledWrapper {...styles.fullWidthInput}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Requested credit limit")}
                                    value={creditLimit}
                                    onChange={e => creditLimitHandler(e.currentTarget.value)}
                                    // error={isSubmitted}
                                />
                            </StyledWrapper>
                        </GridItem>
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
            <StyledWrapper {...styles.captchaWrapper}>
                <ReCaptcha recaptchaRef={recaptchaRef} location="ContactUs" />
            </StyledWrapper>
            <GridItem
                {...styles.submitGridItem}
                {...CreateAccountExistingFormStyles.flexStart}
                {...CreateAccountExistingFormStyles.marginTop}
                {...CreateAccountExistingFormStyles.removePadding}
            >
                <Button
                    {...styles.submitButton}
                    onClick={submitHandler}
                    data-test-selector="createAccount_createButton"
                >
                    {translate("Submit Application and Register Now")}
                </Button>
            </GridItem>
            <Typography as="p" {...CreateAccountExistingFormStyles.termsAndConditions}>
                {translate('By clicking the "Submit Application" button, you agree to Cooney Brothers')}{" "}
                <Link {...CreateAccountExistingFormStyles.linkStyle} href="/TermsandConditions" target="_blank">
                    Terms and Conditions
                </Link>
            </Typography>
            <StyledWrapper {...CreateAccountExistingFormStyles.marginTop}>
                {errorMessage && (
                    <GridItem {...styles.submitErrorGridItem}>
                        <Typography {...CreateAccountExistingFormStyles.serverError}>{errorMessage}</Typography>
                    </GridItem>
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CreditApplicationForm),
    definition: {
        group: "Contact Us",
        icon: "FormField",
        fieldDefinitions: [],
    },
};

export default widgetModule;
